const splitUrlPiece = (splitter: string, url = '') => {
  if (url.indexOf(splitter) < 0) {
    url = `${url}${splitter}`;
  }
  const splitterIndex = url.indexOf(splitter);
  return {
    baseHref: url.substring(0, splitterIndex),
    queryString: url.substring(splitterIndex + 1),
  };
};

export default splitUrlPiece;
